import postal from 'postal';
import { constants, event } from '../constants/index.js';
import { buildHashParameter } from '../helpers/utils.js';

const { MATERIALBOX_CLOSE, MATERIALBOX_OPENED, MATERIALBOX_CLOSED, USER_LOGIN_SUCCESS, SET_HASH } = event;
const { 
	SSO_OVERLAY_TYPES: { LOGIN, REGISTER}, 
	SSO_HASH_PARAMETERS: { MODEL, CONTEXT_NAME, REDIRECTION_PATH}
} = constants;

function subscribe(event, callback) {
	return postal.subscribe({
		channel: event.CHANNEL,
		topic: event.TOPIC,
		callback
	});
}

function publish(event, data) {
	postal.publish({
		channel: event.CHANNEL,
		topic: event.TOPIC,
		data
	});
}

function subscribeToMaterialBoxClose(callback) {
	return subscribe(MATERIALBOX_CLOSE, callback);
}
function subscribeToMaterialBoxOpened(callback) {
	return subscribe(MATERIALBOX_OPENED, callback);
}
function subscribeToMaterialBoxClosed(callback) {
	return subscribe(MATERIALBOX_CLOSED, callback);
}
function subscribeToUserLoginSuccess(callback) {
	return subscribe(USER_LOGIN_SUCCESS, callback);
}

const triggerOverlayEvent = overlayType => () => {
	
	const isRegister = overlayType === REGISTER;
	const data = isRegister ? '/sso/register/autoclose=true' : '/sso/login/autoclose=true'

	publish(SET_HASH, 
		`${data}` + 
		`${buildHashParameter(MODEL, 'lbx-experience' )}` +
		`${buildHashParameter(CONTEXT_NAME, 'lbx-experience')}` +
		`${buildHashParameter(REDIRECTION_PATH, window.location.pathname)}`
	);
};

const triggerLoginOverlayEvent = triggerOverlayEvent(LOGIN);
const triggerRegisterOverlayEvent = triggerOverlayEvent(REGISTER);

export {
	triggerLoginOverlayEvent,
	triggerRegisterOverlayEvent,
    subscribeToMaterialBoxClose,
    subscribeToMaterialBoxOpened,
    subscribeToMaterialBoxClosed,
    subscribeToUserLoginSuccess
};